import React, {createContext, useContext, useState} from 'react'
import {cloneObject} from "src/Lib/Helper/Functions";

/**
 * @step 1721- provider to keep  global variables
 * @type {React.Context<undefined>}
 */
const GlobalContext = createContext();

export function useGlobalSet() {
    return useContext(GlobalContext)
}

export function GlobeProvider({children}) {
    const [globalSet, setGlobalSet] = useState({});

    /**
     *  step 1721- 1 each spk make and key here with here items, its mean each spk on can set variable in here group
     * @param spkId
     * @param key
     * @param value
     * @constructor
     */
    const ChangeGlobalSet = (spkId, key, value = null) => {
        const st = cloneObject(globalSet);
        if (!st[spkId]) {
            st[spkId] = {};
        }
        if (typeof key === "object") {
            for (let item of Object.keys(key)) {
                if (spkId && item ) {
                    st[spkId][item] = key[item];
                }
            }
        } else {
            st[spkId][key] = value;
        }
        setGlobalSet(st);
    }

    return (
        <GlobalContext.Provider value={{globalSet, ChangeGlobalSet}}>
            {children}
        </GlobalContext.Provider>
    )
}
